import axios from "api/axios";
import { parameterizeArray } from "utils/urlParser";
import { LIST_SOFTWARE_PAGE_SIZE } from ".";

import {
  ICreateProjectParams,
  IProject,
  IGallery,
  IUpdateProjectParams,
  IUserProject,
  ICreateCommentParams,
  IComment,
  IProjectInProgress,
  IUpdateProjectOverview,
  IUpdateProjectDetail,
  IUpdateCommentParams,
  ICreateProjectTopicParams,
  IUpdateProjectTopicParams,
  IProjectTopic,
  IUpdateProjectAdditional,
  IUpdateProjectDecribeParams,
  IListSoftwarePayload,
  IListSoftware,
  IListSoftwareBase,
  IUpdateTeammatePayload,
  ISecretTeammatePayload,
  IRequestTeamUpParams,
  ISkipTeammatePayload,
  IInfinitySoftware,
  IInfinitySoftwarePayload,
  ICreateProjectReview,
  IProjectReview,
  IAddTeamMember,
  IUpdateTeammemberPayload,
} from "./types";

export const createInHackathonProjectRequest = async (
  hackathonId: string
): Promise<IProject> => {
  const { data } = await axios({
    url: "/project/in_hackathon",
    method: "POST",
    data: { hackathonId: hackathonId },
  });
  return data;
};

export const createDraftProjectRequest = async (
  params: ICreateProjectParams
): Promise<IProject> => {
  const { data } = await axios({
    url: "/project/draft_project",
    method: "POST",
    data: params,
  });
  return data;
};

export const updateProjectRequest = async (
  projectId: string,
  params: IUpdateProjectParams
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/update_project/${projectId}`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const getProjectByIdRequest = async (
  projectId: string
): Promise<IProject> => {
  const { data } = await axios({
    url: `project/detail/${projectId}`,
    method: "GET",
  });
  return data;
};

export const getAllProjectByUserIdRequest = async (
  userId: string
): Promise<IUserProject> => {
  const { data } = await axios({
    url: `project/find_all_by_user/${userId}`,
    method: "GET",
  });
  return data;
};

export const getAllUserProject = async (): Promise<IProject[]> => {
  const { data } = await axios({
    url: `project/find_all`,
    method: "GET",
  });
  return data;
};

export const getImportableProject = async (
  hackathonId: string
): Promise<IProject[]> => {
  const { data } = await axios({
    url: `project/list_project_can_import/${hackathonId}`,
    method: "GET",
  });
  return data;
};

export const deleteProjectRequest = async (
  projectId: string
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/remove/${projectId}`,
    method: "DELETE",
  });
  return data;
};

// Gallery

export const createGalleryRequest = async (
  projectId: string,
  params: IGallery
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/image_gallery/${projectId}`,
    method: "POST",
    data: params,
  });
  return data;
};

export const updateGalleryRequest = async (
  projectId: string,
  params: IGallery
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/image_gallery/${projectId}`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const sortGalleryRequest = async (
  projectId: string,
  params: string[]
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/sort_image_gallery/${projectId}`,
    method: "PUT",
    data: { imageGallerys: params },
  });
  return data;
};

export const deleteGalleryRequest = async (
  projectId: string,
  galleryId: string
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/image_gallery/${projectId}`,
    method: "DELETE",
    data: { _id: galleryId },
  });
  return data;
};

export const likeProjectRequest = async (
  projectId: string
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/like`,
    method: "PUT",
    data: { projectId: projectId },
  });
  return data;
};

export const dislikeProjectRequest = async (
  projectId: string
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/unlike`,
    method: "PUT",
    data: { projectId: projectId },
  });
  return data;
};

// Comment

export const createCommentRequest = async (
  params: ICreateCommentParams
): Promise<IComment> => {
  const { data } = await axios({
    url: `/comment`,
    method: "POST",
    data: params,
  });
  return data;
};

export const updateCommentRequest = async (
  params: IUpdateCommentParams
): Promise<IComment> => {
  const { data } = await axios({
    url: `/comment/update_comment`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const deleteCommentRequest = async (
  commentId: string
): Promise<IComment> => {
  const { data } = await axios({
    url: `/comment/remove/${commentId}`,
    method: "DELETE",
  });
  return data;
};

export const flagCommentRequest = async (params: {
  commentId: string;
  reason: string;
}): Promise<IComment> => {
  const { data } = await axios({
    url: `/comment/flag`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const starProjectRequest = async (projectId: string): Promise<any> => {
  const { data } = await axios({
    url: `/project/star`,
    method: "PUT",
    data: { projectId },
  });
  return data;
};

export const unstarProjectRequest = async (projectId: string): Promise<any> => {
  const { data } = await axios({
    url: `/project/unstar`,
    method: "PUT",
    data: { projectId },
  });
  return data;
};

export const hiddenProjectRequest = async (projectId: string): Promise<any> => {
  const { data } = await axios({
    url: `/project/hidden`,
    method: "PUT",
    data: { projectId },
  });
  return data;
};

export const unhiddenProjectRequest = async (
  projectId: string
): Promise<any> => {
  const { data } = await axios({
    url: `/project/unhidden`,
    method: "PUT",
    data: { projectId },
  });
  return data;
};

export const getHackathonMyProjectRequest = async (
  hackathonId: string
): Promise<IProjectInProgress[]> => {
  const { data } = await axios({
    url: `/hackathon/my_project/${hackathonId}`,
    method: "GET",
  });
  return data;
};

export const importProjectRequest = async (
  projectId: string,
  hackathonId: string
): Promise<any> => {
  const { data } = await axios({
    url: `/project/import_to_hackathon`,
    method: "PUT",
    data: {
      projectId: projectId,
      hackathonId: hackathonId,
    },
  });
  return data;
};

export const updateProjectOverviewRequest = async (
  projectId: string,
  params: IUpdateProjectOverview
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/overview/${projectId}`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const updateProjectDetailRequest = async (
  projectId: string,
  params: IUpdateProjectDetail
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/detail/${projectId}`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const updateProjectAdditionalRequest = async (
  projectId: string,
  params: IUpdateProjectAdditional
): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/additional/${projectId}`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const submitProjectRequest = async (params: {
  projectId: string;
  hackathonId: string;
  transactionId?: string;
  walletAddress?: string;
}): Promise<IProject> => {
  const { data } = await axios({
    url: `/project/submit`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const deleteSubmissionRequest = async (
  submissionId: string
): Promise<any> => {
  const { data } = await axios({
    url: `/submission/remove/${submissionId}`,
    method: "DELETE",
  });
  return data;
};

export const getProjectTopicListRequest = async (
  projectId: string
): Promise<IProjectTopic[]> => {
  const { data } = await axios({
    url: `/topic/project_list/${projectId}`,
    method: "GET",
  });
  return data;
};

export const createProjectUpdateCommentRequest = async (
  params: ICreateProjectTopicParams
): Promise<IProjectTopic> => {
  const { data } = await axios({
    url: "/topic/create",
    method: "POST",
    data: params,
  });
  return data;
};

export const updateProjectTopicRequest = async (
  params: IUpdateProjectTopicParams
): Promise<IProjectTopic> => {
  const { data } = await axios({
    url: "/topic/update",
    method: "PUT",
    data: params,
  });
  return data;
};

export const deleteTopicRequest = async (
  topicId: string
): Promise<IProjectTopic> => {
  const { data } = await axios({
    url: `/topic/remove/${topicId}`,
    method: "DELETE",
  });
  return data;
};

export const flagTopicRequest = async (params: {
  topicId: string;
  reason: string;
}): Promise<IProjectTopic> => {
  const { data } = await axios({
    url: `/topic/flag`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const updateProjectDescribe = async (
  params: IUpdateProjectDecribeParams
): Promise<IProjectTopic> => {
  const { data } = await axios({
    url: `/project/describe`,
    method: "PUT",
    data: params,
  });
  return data;
};

export const getListSoftwareRequest = async (
  params: IListSoftwarePayload
): Promise<IListSoftware> => {
  const search = `search=${params?.search || ""}`;
  const sort_type = params.sort_type ? `&sort_type=${params?.sort_type}` : "";
  const filter_type = params?.filter_type
    ? `&filter_type=${params?.filter_type}`
    : "";
  const childTag = parameterizeArray("childTag", params.childTag);

  const { data } = await axios({
    url: `/project/software/all?${search}${sort_type}${childTag}${filter_type}&page=${
      params.page
    }&pageSize=${params.pageSize || LIST_SOFTWARE_PAGE_SIZE}`,
    method: "GET",
  });
  return data;
};

export const getListInfinitySoftwareRequest = async (
  params: IInfinitySoftwarePayload
): Promise<IInfinitySoftware> => {
  const search = `search=${params?.search || ""}`;
  const sort_type = params.sort_type ? `&sort_type=${params?.sort_type}` : "";
  const filter_categories = params.filter_categories
    ? `&filter_categories=${params?.filter_categories}`
    : "";
  const filter_type = params?.filter_type
    ? `&filter_type=${params?.filter_type}`
    : "";
  const childTag = parameterizeArray("filter_value", params.childTag);

  const { data } = await axios({
    url: `/project/explore-project?${search}${sort_type}${childTag}${filter_categories}${filter_type}&page=${
      params.page
    }&pageSize=${params.pageSize || LIST_SOFTWARE_PAGE_SIZE}`,
    method: "GET",
  });
  return data;
};

export const getListSoftwareBaseRequest =
  async (): Promise<IListSoftwareBase> => {
    const { data } = await axios({
      url: `/project/software?limit_popular_project=${16}&limit_friend_project=${4}`,
      method: "GET",
    });
    return data;
  };

export const addTeammateToProjectRequest = async (
  params: IUpdateTeammatePayload
): Promise<any> => {
  return await axios({
    url: `/project/add-team-mate`,
    method: "POST",
    data: params,
  });
};
export const addTeamMemberRequest = async (
  params: IAddTeamMember
): Promise<any> => {
  return await axios({
    url: `/project/add-team-member`,
    method: "POST",
    data: params,
  });
};

export const removeTeammateFromProjectRequest = async (
  params: IUpdateTeammatePayload
): Promise<any> => {
  const { data } = await axios({
    url: `/project/remove-team-mate`,
    method: "POST",
    data: params,
  });
  return data;
};

export const removeTeamMemberRequest = async (
  params: IUpdateTeammemberPayload
): Promise<any> => {
  const { data } = await axios({
    url: `/project/remove-team-member`,
    method: "POST",
    data: params,
  });
  return data;
};

export const skipTeammateRequest = async (
  params: ISkipTeammatePayload
): Promise<any> => {
  const { data } = await axios({
    url: `/project/skip-team-mate/${params.projectId}`,
    method: "POST",
  });
  return data;
};

export const secretTeammateRequest = async (
  params: ISecretTeammatePayload
): Promise<any> => {
  const { data } = await axios({
    url: `/project/secret-team-mate`,
    method: "POST",
    data: params,
  });
  return data;
};

export const requestTeamUpRequest = async (
  params: IRequestTeamUpParams
): Promise<any> => {
  const { data } = await axios({
    url: `/participant/request-team-up`,
    method: "POST",
    data: params,
  });
  return data;
};

export const createProjectReview = async (params: ICreateProjectReview) => {
  return await axios({
    url: "/review/create",
    method: "POST",
    data: params,
  });
};

export const getListProjectReview = async (projecId: string) => {
  const { data } = await axios({
    url: `/review/list_by_project/${projecId}`,
    method: "get",
  });
  return data;
};

export const getListRelativeProject = async (projecId: string) => {
  const { data } = await axios({
    url: `/project/relative_project/${projecId}`,
    method: "get",
  });
  return data;
};
